(function () {
  const initImageCarousel = (section) => {
    if (!section || !section?.classList.contains("image-carousel-section")) {
      return;
    }

    const slider = section.querySelector(".image-carousel__media--slider");

    if (!slider) return;

    const sliderWrapper = slider.querySelector(
      ".image-carousel__media-wrapper"
    );
    const sliderSpeed = Number(slider.dataset?.sliderSpeed || 15000);
    const sliderSpeedMob = sliderSpeed * 0.8;
    const sliderDirection = slider.dataset?.sliderDirection || "right_to_left";
    const reverseDirection = sliderDirection === "left_to_right" ? true : false;

    const imageCarouselSwiper = new Swiper(slider, {
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: false,
      freeModeMomentum: false,
      resizeObserver: true,
      speed: sliderSpeedMob,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: reverseDirection,
      },
      spaceBetween: 4,
      watchSlidesProgress: true,
      breakpoints: {
        576: { speed: sliderSpeed },
      },
    });

    slider.addEventListener("pointerdown", () => {
      imageCarouselSwiper.autoplay.start();
    });
  };

  initImageCarousel(document.currentScript.parentElement);

  document.addEventListener("shopify:section:select", function (event) {
    initImageCarousel(event.target);
  });

  document.addEventListener("shopify:block:change", function (event) {
    initImageCarousel(event.target);
  });

  document.addEventListener("shopify:section:change", function (event) {
    initImageCarousel(event.target);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initImageCarousel(event.target);
  });
})();
